var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wall_clock-time-heart-love-valentine"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,40C136.707,40,40,136.707,40,256s96.707,216,216,216s216-96.707,216-216S375.293,40,256,40z M264,423.596V376   c0-4.418-3.582-8-8-8s-8,3.582-8,8v47.596C161.626,419.518,92.482,350.374,88.404,264H136c4.418,0,8-3.582,8-8s-3.582-8-8-8H88.404   C92.481,161.626,161.626,92.482,248,88.404V136c0,4.418,3.582,8,8,8s8-3.582,8-8V88.404   C350.374,92.481,419.519,161.626,423.596,248H376c-4.418,0-8,3.582-8,8s3.582,8,8,8h47.596   C419.518,350.374,350.374,419.519,264,423.596z M349.656,338.344c3.125,3.125,3.125,8.188,0,11.313   C348.094,351.219,346.047,352,344,352s-4.094-0.781-5.656-2.344l-60.175-60.175l-8.907,9.004c-7.318,7.398-19.204,7.398-26.522,0   l-32.5-32.855c-11.85-11.979-13.889-31.229-3.614-44.605c12.415-16.161,35.529-17.243,49.375-3.245   c9.338-9.44,22.841-11.853,34.485-7.577l31.859-31.859c3.125-3.125,8.188-3.125,11.313,0s3.125,8.188,0,11.313l-29.79,29.79   c0.486,0.555,1.052,0.983,1.509,1.579c10.275,13.375,8.235,32.626-3.614,44.605l-12.342,12.477L349.656,338.344z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.96c85f2a959ef789252bc9cffcead856.svg";
export { ForwardRef as ReactComponent };